import i18n from "i18next";

export const categories = [
    i18n.t("referenzenPage.categories.all"),
    i18n.t("referenzenPage.categories.rooftop"),
    i18n.t("referenzenPage.categories.flatRoof"),
    i18n.t("referenzenPage.categories.enginnering"),
];
